
let lastComponent = null;
export default {
    props: {
        widgets: {
            type: Array,
            required: true,
        },
    },
    methods: {
        /**
         * @param {Function} createElement
         * @param {Object} widget
         * @returns {Object}
         */
        getWidgetComponent(createElement, widget) {
            let padding = true;
            if (!widget.sys.contentType) {
                /* Content type has been deleted, but references still exists */
                return;
            }
            if (lastComponent === widget.sys.contentType.sys.id) {
                padding = false;
            }
            lastComponent = widget.sys.contentType.sys.id;

            return createElement(this.widgetTagName(widget.sys.contentType.sys.id), {
                props: {
                    widget,
                    padding,
                },
            });
        },
        calculateAvailableHeight() {
            if (process.client) {
                const headerHeight = document.getElementById('header')?.offsetHeight || 0;
                const bannerHeight = document.getElementById('banner')?.offsetHeight || 0;
                const windowHeight = window.innerHeight
                return windowHeight - headerHeight - bannerHeight;
            }

            return 0;
        },

        /**
         * @param {String} type - ex. 'content_full'
         * @returns {string} - ex. 'content-full'
         */
        widgetTagName(type) {
            return `contentful-${type}`;
        },
    },
    render(createElement) {
        const widgetComponents = this.widgets.map((widget) => this.getWidgetComponent(createElement, widget));
        const minHeight = this.calculateAvailableHeight();

        return createElement(
            'main',
            {
                attrs: {
                    class: 'widget-list',
                },
                style: {
                    minHeight: `${minHeight}px`,
                },
            },
            widgetComponents,
        );
    },
};
